import JitsiMeetJSRaw from './cometchat-webrtc.min.js?raw';
import type { IJitsiMeetJS } from './type';

declare let JitsiMeetJS: IJitsiMeetJS;

if (!window.JitsiMeetJS) {
  const script = document.createElement('script');
  script.text = JitsiMeetJSRaw;
  document.head.appendChild(script);
}

declare global {
  interface Window {
    JitsiMeetJS: IJitsiMeetJS;
    APP: {
      conference: {
        _room?: any;
        getConnectionState: () => string | undefined;
        getStats: () => any;
      };
      connection?: any;
    };
  }
}

if (process.env.NODE_ENV === 'production') {
  JitsiMeetJS.setLogLevel(JitsiMeetJS.logLevels.ERROR);
}

window.APP = {
  conference: {
    getConnectionState: () => {
      return window.APP.conference._room?.getConnectionState();
    },
    getStats: () => {
      return window.APP.conference._room?.connectionQuality?.getStats();
    },
  },
};

JitsiMeetJS.setLogLevel(JitsiMeetJS.logLevels.ERROR);

export default JitsiMeetJS;
